module.exports = __webpack_public_path__ + "img/palazzi_storici.57741179.jpg";